import { SliderVideo } from '@components/slider-video/models';
import { videoMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const sliderVideoMock = (withCta: boolean = false): Block<SliderVideo> => ({
  type: 'slider-video',
  data: {
    title: {
      text: `Les atouts de la cuisine [[Latte]]`,
      as: 'span',
    },
    videos: [videoMock(true, 1), videoMock(true, 2), videoMock(true, 3)],
    cta: withCta
      ? {
          label: `Je découvre les prix SoCoo'c`,
          url: '/mock-les-prix',
        }
      : undefined,
  },
});
